import { render, staticRenderFns } from "./CartaoTap.vue?vue&type=template&id=1b525f91&scoped=true"
import script from "./CartaoTap.vue?vue&type=script&lang=js"
export * from "./CartaoTap.vue?vue&type=script&lang=js"
import style0 from "./CartaoTap.vue?vue&type=style&index=0&id=1b525f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b525f91",
  null
  
)

export default component.exports